import React from "react";
//port BackendEngineeringContent from "../function-components/Courses/BackendEngineeringContent";
import WebDeveloperContent from "../function-components/Courses/WebDeveloperContent";

function WebDeveloper({bannerimg}) {
  return (
    <>
      <WebDeveloperContent bannerimg={bannerimg}/>
    </>
  );
}

export default WebDeveloper;
